import { render, staticRenderFns } from "./ConfigureModality.vue?vue&type=template&id=0f672cc0"
import script from "./ConfigureModality.vue?vue&type=script&lang=js"
export * from "./ConfigureModality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports